<template>
  <div class="custom-select-wrapper" ref="selectWrapper">
    <label v-if="label" class="select-label">
      {{ label }}
    </label>
    <div class="custom-select fontSize4" :class="{ open: isOpen }" @click.stop="toggleOpen">
    <div class="selected fontSize4" :class="{ placeholder: !selectedValue || selectedValue === placeholder }">
          {{ selectedValue ? selectedValue : placeholder }}
      </div>
      <div class="items" :class="{ selectHide: !isOpen }">
        <div
          v-for="(option, index) in options"
          :key="index"
          @click.stop="selectOption(option, $event)"
          class="fontSize4"
          :class="{ selected: option.value === value }"
        >
          {{ option.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../event-bus';

export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      selectedValue: this.getSelectedText(),
    };
  },
  watch: {
    value(newValue) {
      // 根据新值找到对应的选项文本
      const option = this.options.find(opt => opt.value === newValue);
      this.selectedValue = option ? option.text : newValue;
    },
  },
  mounted() {
    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleClickOutside);
    // 监听全局关闭事件
    EventBus.$on('close-all-selects', this.handleCloseAllSelects);
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
    // 移除全局关闭事件监听
    EventBus.$off('close-all-selects', this.handleCloseAllSelects);
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        // 当当前下拉框打开时，通知其他下拉框关闭
        EventBus.$emit('close-all-selects', this._uid);
      }
    },
    selectOption(option, event) {
      this.selectedValue = option.text; // 显示文本而不是值
      this.$emit('input', option.value);
      this.isOpen = false; // 选择后关闭下拉框
      // 阻止事件冒泡，确保下拉框能正确收起
      if (event) {
        event.stopPropagation();
      }
    },
    handleClickOutside(event) {
      // 检查点击是否在组件外部
      if (this.$refs.selectWrapper && !this.$refs.selectWrapper.contains(event.target)) {
        this.isOpen = false;
      }
    },
    handleCloseAllSelects(openedSelectUid) {
      // 如果接收到的事件不是由当前组件发出的，则关闭当前组件
      if (this._uid !== openedSelectUid) {
        this.isOpen = false;
      }
    },
    getSelectedText() {
      // 根据当前值获取对应的文本
      const option = this.options.find(opt => opt.value === this.value);
      return option ? option.text : this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-select-wrapper {
  position: relative;
  width: 100%;

  .select-label {
    position: absolute;
    width: 1.2rem;
    height: .75rem;
    line-height: .75rem;
    font-size: .26rem;
    top: 0;
    left: .18rem;
    text-align: justify;
    text-align-last: justify;
    color: #333;
    z-index: 2;

    &:after {
      content: ':';
      display: block;
      position: absolute;
      top: 0;
      right: -.15rem;
      height: .8rem;
      line-height: .8rem;
    }
  }
}

.custom-select {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #5b6f84;
  border-radius: .05rem;
  cursor: pointer;
  height: .74rem;
  line-height: .74rem;
  font-size: .26rem;
  color: #333;
  background-color: #fff;
  box-sizing: border-box;
  outline: #5b6f84;

  .selected {
    padding-left: 1.8rem;
    padding-right: 0.4rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    color: #000;
    font-weight: normal;

    &.placeholder {
      color: #ccc;
      font-weight: normal;
    }
  }

  &::after {
    content: '';
    position: absolute;
    right: 0.2rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 0.1rem solid transparent;
    border-right: 0.1rem solid transparent;
    border-top: 0.1rem solid #333;
    pointer-events: none;
    transition: transform 0.3s ease;
  }

  &.open::after {
    transform: translateY(-50%) rotate(180deg);
  }
}

.items {
  position: absolute;
  top: .78rem;
  left: 0;
  right: 0;
  border: 1px solid #5b6f84;
  //border-top: none;
  border-radius: .05rem;
  background-color: #fff;
  z-index: 100;
  max-height: 3rem;
  overflow-y: auto;
  opacity: 1;
  transform: translateY(0);
  transition: all 0.3s ease;

  div {
      padding-left: 1.8rem;
      padding-right: 0.2rem;
      cursor: pointer;
      height: .74rem;
      line-height: .74rem;
      color: #000;
      font-weight: normal;

      &:hover {
        background-color: #f0f0f0;
      }

      &.selected {
        background-color: #e0e0e0;
      }
    }
}

.selectHide {
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
}
</style>